import { render, staticRenderFns } from "./crmContainer.vue?vue&type=template&id=0fe7fc32&"
import script from "./crmContainer.vue?vue&type=script&lang=js&"
export * from "./crmContainer.vue?vue&type=script&lang=js&"
import style0 from "./crmContainer.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports